"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
var userDefWatchId;
exports.default = (element) => __awaiter(void 0, void 0, void 0, function* () {
    const ajax = yield window.ArzLibs.ajax();
    const user = yield window.account.checkUserLogin();
    // const loading = ref<{[key:string]:boolean}>({});
    var isCoinDetail = $('.mobile #coin-details-page').length;
    if (user) {
        const token = window.account.headerToken();
        doLoading(element, true);
        ajax.send2(arzConstants.NEXUS_BASEURL + `/v1/watchlist?is_default=true`, {
            headers: token
        }).then((res) => {
            doLoading(element, false);
            if (res.status === "success") {
                userDefWatchId = res.data.watchlist_id;
                for (const item of res.data.coins) {
                    var aa = $(`[data-w-assetid="${item.id}"]`);
                    if (aa.length) {
                        if (isCoinDetail) {
                            aa.find('.uicon').removeClass(' icon-star').addClass(' icon-star-filled');
                            aa.find('.text').text('حذف از تحت نظر');
                        }
                        else {
                            aa.removeClass('arz-tw-stroke-gray-500').addClass('arz-tw-stroke-yellow-500');
                        }
                    }
                }
            }
        }).catch(() => {
            doLoading(element, false);
        });
    }
    ;
    element.forEach((button) => {
        button.on('click', function () {
            return __awaiter(this, void 0, void 0, function* () {
                const el = $(this);
                //if (el.hasClass('arz-tw-opacity-50')) return;
                return window.arz_runAuthenticatedAction({
                    triggerElement: 'add_to_watchlist_shortcut',
                    action: function () {
                        return __awaiter(this, void 0, void 0, function* () {
                            doLoading([el], true);
                            const token = window.account.headerToken();
                            const id = el.data('w-assetid');
                            var add;
                            if (isCoinDetail) {
                                add = el.find('.uicon').hasClass('icon-star-filled');
                            }
                            else
                                add = el.hasClass('arz-tw-stroke-yellow-500');
                            const body = {
                                assets: [
                                    id
                                ]
                            };
                            var url;
                            var method;
                            if (add) {
                                if (!userDefWatchId) {
                                    return;
                                }
                                method = 'DELETE';
                                url = arzConstants.NEXUS_BASEURL + `/v1/watchlist/${userDefWatchId}/remove-coin`;
                            }
                            else {
                                if (!userDefWatchId) {
                                    var makeWatchlist = yield ajax.send2(arzConstants.NEXUS_BASEURL + `/v1/watchlist`, {
                                        method: 'POST',
                                        headers: token,
                                        body: JSON.stringify({
                                            name: "لیست تحت نظر من",
                                        }),
                                        contentType: 'application/json'
                                    });
                                    if (makeWatchlist.status == 'success') {
                                        userDefWatchId = makeWatchlist.data.id;
                                    }
                                    else {
                                        arzDigital.snackbar(`خطا در ایجاد لیست تحت نظر رخ داده. لطفا بعدا دوباره سعی کنید.`, 'error');
                                    }
                                }
                                method = 'POST';
                                url = arzConstants.NEXUS_BASEURL + `/v1/watchlist/${userDefWatchId}/add-coin`;
                            }
                            ajax.send2(url, {
                                method,
                                headers: token,
                                body: JSON.stringify(body),
                                contentType: 'application/json'
                            }).then((res) => {
                                doLoading([el], false);
                                if (res.status === "success") {
                                    if (!add) {
                                        if (isCoinDetail) {
                                            el.find('.uicon').removeClass('icon-star').addClass('icon-star-filled');
                                            el.find('.text').text('حذف از تحت نظر');
                                        }
                                        else {
                                            el.removeClass('arz-tw-stroke-gray-500').addClass('arz-tw-stroke-yellow-500');
                                        }
                                    }
                                    else {
                                        if (isCoinDetail) {
                                            el.find('.uicon').removeClass('icon-star-filled').addClass('icon-star');
                                            el.find('.text').text('افزودن به تحت نظر');
                                        }
                                        else {
                                            el.removeClass('arz-tw-stroke-yellow-500').addClass('arz-tw-stroke-gray-500');
                                        }
                                    }
                                }
                            });
                        });
                    }
                });
            });
        });
    });
    function doLoading(els, action) {
        els.forEach((el) => {
            if (action) {
                el.addClass('arz-tw-opacity-50');
            }
            else {
                el.removeClass('arz-tw-opacity-50');
            }
        });
    }
});
